import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface LoadingSkeletonProps {
  width?: string | number;
  borderRadius?: string | number;
  backgroundColor?: string;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ width, borderRadius = 6, backgroundColor = '#eaeaea' }) => {
  return <Skeleton width={width} borderRadius={borderRadius} baseColor={backgroundColor} />;
};

export default LoadingSkeleton;
